import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\BankAccount\UpdateBankAccountController::__invoke
* @see app/Http/Controllers/BankAccount/UpdateBankAccountController.php
* @route '/api/bank-account/{bank_account}'
*/
const UpdateBankAccountController = (args: { bank_account: string | number | { id: string | number } } | [bank_account: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateBankAccountController.url(args, options),
    method: 'put',
})

UpdateBankAccountController.definition = {
    methods: ["put"],
    url: '/api/bank-account/{bank_account}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\BankAccount\UpdateBankAccountController::__invoke
* @see app/Http/Controllers/BankAccount/UpdateBankAccountController.php
* @route '/api/bank-account/{bank_account}'
*/
UpdateBankAccountController.url = (args: { bank_account: string | number | { id: string | number } } | [bank_account: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { bank_account: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { bank_account: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            bank_account: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        bank_account: typeof args.bank_account === 'object'
        ? args.bank_account.id
        : args.bank_account,
    }

    return UpdateBankAccountController.definition.url
            .replace('{bank_account}', parsedArgs.bank_account.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\BankAccount\UpdateBankAccountController::__invoke
* @see app/Http/Controllers/BankAccount/UpdateBankAccountController.php
* @route '/api/bank-account/{bank_account}'
*/
UpdateBankAccountController.put = (args: { bank_account: string | number | { id: string | number } } | [bank_account: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateBankAccountController.url(args, options),
    method: 'put',
})

export default UpdateBankAccountController